export const getButtonTitle = ({
    base,
    vizName,
    screenReaderText,
}: {
    base: string;
    vizName?: string;
    screenReaderText?: string;
}) => {
    if (screenReaderText) {
        return screenReaderText;
    }
    return vizName ? `${base}, ${vizName}` : base;
};
